// src/features/search/searchSelectors.ts

import { RootState } from '@/app/store';
import { SearchTab } from '@/types/search.types';

export const selectSearchQuery = (state: RootState) => state.search.query;
export const selectSearchResults = (state: RootState) => state.search.results;
export const selectSearchLoading = (state: RootState) => state.search.loading;
export const selectSearchError = (state: RootState) => state.search.error;
export const selectActiveTab = (state: RootState) => state.search.activeTab;

export const selectNewsResults = (state: RootState) => state.search.results.news;
export const selectEventsResults = (state: RootState) => state.search.results.events;
export const selectInstitutionalResults = (state: RootState) => state.search.results.institutional;
export const selectSitesResults = (state: RootState) => state.search.results.sites;
export const selectFormsResults = (state: RootState) => state.search.results.forms;

export const selectTotalResults = (state: RootState) => {
  const { news, events, institutional, sites, forms } = state.search.results;
  return news.length + events.length + institutional.length + sites.length + forms.length;
};

export const selectResultsByTab = (state: RootState, tab: SearchTab) => {
  const results = state.search.results;
  switch (tab) {
    case SearchTab.NEWS:
      return results.news;
    case SearchTab.EVENTS:
      return results.events;
    case SearchTab.INSTITUTIONAL:
      return results.institutional;
    case SearchTab.SITES:
      return results.sites;
    case SearchTab.FORMS:
      return results.forms;
    case SearchTab.ALL:
    default:
      return results;
  }
};
